module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/announcements_bg_with_quests_big.0d40b15f.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/images/announcements_bg_with_quests_big.jpg
// module id = 2890
// module chunks = 11